
  const BlackHillsCalc = ([jan, feb, mar, apr, ma, jun, jul, aug, sep, oct, nov, dec]) => {

    const surcharge = 8.77

    // This calculates how much someone will pay for black hills electric...

    // cost per kWh
    const tier1 = 0.09999
    const tier2 = 0.13004

    const energyCost = .040
    const transmissionCost = .002069
    const purchCap = .00077
    const cleanAir = .00444

    // functions to get bill amounts for each month
    const month = (num) => {
      let tier = 500 * tier1
      let a = num * energyCost
      let b = num * transmissionCost
      let c = num * purchCap
      let d = num * cleanAir

      if (num > 500) {
        return (num - 500) * tier2 + tier + (a + b + c + d) + surcharge
      }
      return num * tier1 + (a + b + c + d) + surcharge
    }


    let january = month(jan).toFixed(2)
    let february = month(feb).toFixed(2)
    let march = month(mar).toFixed(2)
    let april = month(apr).toFixed(2)
    let may = month(ma).toFixed(2)
    let june = month(jun).toFixed(2)
    let july = month(jul).toFixed(2)
    let august = month(aug).toFixed(2)
    let september = month(sep).toFixed(2)
    let october = month(oct).toFixed(2)
    let november = month(nov).toFixed(2)
    let december = month(dec).toFixed(2)

    let bills = [+january, +february, +march, +april, +may, +june, +july, +august, +september, +october, +november, +december]
    let usage = [+jan, +feb, +mar, +apr, +ma, +jun, +jul, +aug, +sep, +oct, +nov, +dec]
    // console.log(bills)

    const average = (arr) => arr.reduce((a, b) => a + b) / arr.length
    const total = (arr) => arr.reduce((a, b) => a + b)



    let avgBill = average(bills).toFixed(2)
    let avgUsage = Math.floor(average(usage))
    let totalUsage = Math.floor(total(usage))
    let annualBill = total(bills).toFixed(2)

    return [bills, +avgBill, totalUsage, +annualBill, avgUsage]


  }
  export default BlackHillsCalc


